/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-06 14:02:11
 **/

import { useMemo } from "react";

import { useFriendHandlers, usePhoneCall, useSidebarActions } from "@/frameworks/core/hooks";
import { useChatDataStore } from "@/modules/chat/store";
import { SidebarID } from "@/frameworks/core/commons";
import NormalCommands from "../NormalCommands";
export default function NavigateBar(props: PushServices.Call.PhoneDetailProps) {
	const { check_for_floating } = props;
	const sidebarActions = useSidebarActions();
	const phoneCall = usePhoneCall();
	const detailInfo = phoneCall.state.phone_detail[0];
	const isGroupCallHistory = detailInfo.tabID === "group-call-history";
	const callees = phoneCall.state.callees[0];
	const userID = useMemo(() => (callees.length > 0 && callees[0].userID) || "", [callees]);

	const {
		handlers: { handleChat }
	} = useFriendHandlers();

	const handleChatUser = async () => {
		try {
			if (useChatDataStore.getState().show_fullsize_chat) {
				check_for_floating?.();
				await sidebarActions.hideAll("left");
				await sidebarActions.show(SidebarID.Chat);
				await handleChat(userID);
			} else {
				handleChat(userID);
			}
		} catch (error) {
			console.warn("An error occurred while handling chat click:", error);
		}
	};

	return (
		<>
			{!(!isGroupCallHistory && callees.length > 1) && !isGroupCallHistory && (
				<NormalCommands userID={userID} handleChatUser={handleChatUser} />
			)}
		</>
	);
}
